import React from 'react';

import DetachElement from '../../elements/DetachElement';
import ProtectedLink from '../../elements/ProtectedLink';
import { ROLES } from '../../services/AdminPolicyService';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';
import { PERMISSION } from 'crm/helpers/Permissions';

function SubAffiliateDetails({ subAffiliate, url, getSubAffiliate }) {
    const showDetachButton = subAffiliate.register_count === 0;

    return (
        <Card title="Sub Affiliate details">
            <TableDetailsBody>
                <Row label="ID">{subAffiliate.id}</Row>
                <Row label="Medium">{subAffiliate.medium}</Row>
                <Row label="Campaign">{subAffiliate.campaign}</Row>
                <Row label="Content">{subAffiliate.content}</Row>
                <Row label="Link">{subAffiliate.sub_affiliate_link}</Row>
                <Row label="Register count">{subAffiliate.register_count}</Row>
                <Row label="Deposit sum">{subAffiliate.deposit_sum}</Row>
                <Row label="Purchase sum">{subAffiliate.purchase_sum}</Row>
                {subAffiliate.admin_id && (
                    <>
                        <Row label="Affiliate revenue">{subAffiliate.admin_revenue}%</Row>
                        <Row label="Owner">
                            <ProtectedLink
                                url={`/admins/${subAffiliate.admin_id}`}
                                value={subAffiliate.admin_name}
                                permissions={[PERMISSION.VIEW_ADMIN]}
                            />
                            <span className="float-right">
                                {showDetachButton && (
                                    <DetachElement
                                        url={`${url}/admins`}
                                        params={{ admin: subAffiliate.admin_id }}
                                        action={getSubAffiliate}
                                        roles={ROLES.MAIN_ADMINS}
                                    />
                                )}
                            </span>
                        </Row>
                    </>
                )}
            </TableDetailsBody>
        </Card>
    );
}

export default SubAffiliateDetails;
